/**
 * I tre stati del link MFA, e cosa leggono l'artigiano e il bottone.
 *
 * PERCHE' UN MODULO A PARTE: la mappa e il ripiego sono la parte che DECIDE
 * cosa vede chi non riesce ad accedere, ed e' l'unica cosa da provare. Dentro
 * al componente servirebbe montarlo con una libreria che il progetto non ha,
 * per verificare una corrispondenza fra tre costanti e tre frasi. Qui e' una
 * funzione pura: la prova costa dieci righe e non tocca il DOM.
 *
 * ⚠️ IL RIPIEGO NON E' UNA RIFINITURA. Frontend e backend si pubblicano su
 * piattaforme diverse, con tempi diversi: esiste una finestra in cui il
 * frontend NUOVO parla col backend VECCHIO, che non manda `codice`. Se in quel
 * caso mostrassimo un caso ignoto, avremmo ricreato — per quella finestra — il
 * difetto che questa mappa esiste per chiudere. Il ripiego riporta al
 * comportamento PRECEDENTE, che era comunque meglio del nulla.
 *
 * Vale ogni volta che si aggiunge un campo: due cose che si pubblicano
 * separatamente non sono mai aggiornate insieme, quindi l'ASSENZA di un campo
 * nuovo dev'essere un caso previsto, non una sorpresa.
 */

// Tre stati, tre frasi, e ogni frase dice COSA FARE.
//
// Lo stato che capita di piu' e' «scaduto», che NON e' un errore dell'artigiano:
// e' un'attesa che ha superato la finestra. Dirgli «link non valido» gli fa
// credere di aver sbagliato lui.
export const TESTI = {
  link_scaduto: {
    titolo: 'Il link è scaduto',
    spiega: 'I link di accesso durano 10 minuti. Torna al login e chiedine uno nuovo: ci vogliono pochi secondi.',
    azione: 'Richiedi un nuovo link',
  },
  link_gia_usato: {
    titolo: 'Questo link è già stato usato',
    spiega: 'Ogni link vale per un accesso solo. Se hai già confermato, sei dentro; altrimenti torna al login e chiedine uno nuovo.',
    azione: 'Torna al login',
  },
  link_non_valido: {
    titolo: 'Link non valido',
    spiega: "Il link sembra incompleto — a volte succede se l'email lo manda a capo. Prova a copiarlo tutto, oppure chiedine uno nuovo.",
    azione: 'Torna al login',
  },
};

// Il comportamento PRECEDENTE all'introduzione di `codice`: e' il ripiego, e
// non e' una regressione — e' cio' che l'artigiano leggeva prima.
export const RIPIEGO = {
  titolo: 'Verifica fallita',
  azione: 'Torna al login',
};

/**
 * Cosa mostrare, dato il codice del backend e il suo messaggio.
 *
 * @param {string} codice   `link_scaduto` | `link_gia_usato` | `link_non_valido`
 *                          — oppure '' / undefined se il backend non lo manda.
 * @param {string} errore   il messaggio del backend. ⚠️ Su questo percorso puo'
 *                          contenere SOLO frasi scritte da noi: verificato il
 *                          28/08 sulle quattro `errore` di `VerifyMagicLinkView`
 *                          (tutte letterali, nessuna interpolazione di
 *                          eccezione) e sull'assenza di un `EXCEPTION_HANDLER`
 *                          personalizzato — il gestore DRF di default usa
 *                          `detail`, non `errore`. Se un giorno li' dentro
 *                          potesse finire il testo di un'eccezione, questo
 *                          ripiego va sostituito con una frase fissa.
 */
export function testoPerCodice(codice, errore) {
  const noto = TESTI[codice];
  if (noto) return noto;
  return {
    titolo: RIPIEGO.titolo,
    spiega: errore || 'Link non valido o scaduto.',
    azione: RIPIEGO.azione,
  };
}
